export const DEVICE_TYPES = {
    GATEWAY: 0,
    VE_BUS: 1,
    BATTERY_MONITOR: 2,
    IO_EXTENDER: 3,
    SOLAR_CHARGER: 4,
    FLUID_LEVEL: 5,
    SYSTEM_OVERVIEW: 6,
    PV_INVERTER: 7,
    BMS: 8,
    MOTOR_DRIVE: 9,
    CHARGER: 10,
    ZBM_NODE: 11,
    HEATING: 12,
    GRID_METER: 13,
    INVERTER: 14,
    GENERATOR: 15,
    GENERATOR_START_STOP: 16,
    TEMPERATURE_SENSOR: 17,
    GAS_METER: 18,
    PULSE_METER: 19,
    DIGITAL_INPUT: 20,
    DC_METER: 21,
    METEOROLOGICAL_SENSOR: 22,
    FUEL_CELL: 23,
    AC_METER: 24,
    EVCS: 25,
    DC_SOURCE: 26,
    ALTERNATOR: 27,
    DC_LOAD: 28,
    DC_SYSTEM: 29,
    INVERTER_CHARGER: 30,
    DC_DC_CONVERTER: 31,
    SMART_LITHIUM: 32,
    SMART_BATTERY_PROTECT: 33,
    AC_SYSTEM: 34,
    HEAT_PUMP: 35,
    ELECTRIC_VEHICLE: 36,
};
